"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupChatSocketUpdateObservable = void 0;
const mappers_1 = require("../../mappers");
const models_1 = require("../../models");
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
class GroupChatSocketUpdateObservable {
    constructor(chatsStorage, httpAdapter, organizationUser, userDirectory) {
        this.chatsStorage = chatsStorage;
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.userDirectory = userDirectory;
    }
    updateChatListener(cb, chatType, groupType, shouldBringOnTop) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getUpdateChatEventKey)(this.organization.organizationId, chatType, groupType), (data) => {
            const chatLog = (0, mappers_1.groupChatMapper)(data.chatLog, this.userDirectory, this.organizationUser, this.httpAdapter);
            const existingChat = this.chatsStorage.getChatByGroupType(groupType, chatLog.id);
            // Merge chatLog and existingChat, replacing undefined values in chatLog with values from existingChat
            const newChatLog = Object.assign({}, (existingChat || {}));
            Object.keys(chatLog).forEach(key => {
                if (chatLog[key] !== undefined) {
                    newChatLog[key] =
                        chatLog[key];
                }
            });
            this.updateChatToStorage(cb, newChatLog, data.message, groupType, shouldBringOnTop);
        });
    }
    updateChatToStorage(cb, chatLog, message, groupType, shouldBringOnTop) {
        const messageType = message.type;
        const isSelfSender = message.user === this.organization.userProfile.id;
        let updatedChat = Object.assign({}, chatLog);
        const chatList = this.chatsStorage.getChatListByType(groupType);
        const existingChat = chatList.chats.find(chat => chat.id === updatedChat.id);
        // Ignore socket updates if the chat is not in the list (Filtered chats)
        if (!shouldBringOnTop && !existingChat) {
            return;
        }
        if (existingChat) {
            updatedChat = Object.assign(Object.assign({}, updatedChat), { hasPriorityMessage: (!isSelfSender && messageType === models_1.MESSAGE_TYPE.PRIORITY) ||
                    existingChat.hasPriorityMessage, groupInfo: existingChat.groupInfo, isMember: existingChat.isMember });
            // Increment unreadChatCount when a chat transitions from 0 to >0 unread messages
            // Previously: chatLog.unreadCount === 1 (only incremented on first message)
            // Fix for race condition: If second message arrived before first was read, count wouldn't increment
            const shouldUpdateUnreadChatCount = existingChat.unreadCount === 0 &&
                chatLog.unreadCount > 0 &&
                !isSelfSender;
            this.chatsStorage.upsertChat(groupType, updatedChat, shouldUpdateUnreadChatCount, shouldBringOnTop);
        }
        else {
            this.chatsStorage.addChatToChatList(groupType, updatedChat);
        }
        cb(this.chatsStorage.getChatListByType(groupType));
    }
}
exports.GroupChatSocketUpdateObservable = GroupChatSocketUpdateObservable;
